export enum CalculationType {
  ALoRa = "alora",
  QPM = "qpm",
}

export enum CalculationServiceType {
  Installation = "installation",
  Maintenance = "maintenance",
}

export enum CalculationServiceEntryType {
  Unknown = "",
  CheckPoint = "checkpoint",
  CheckPointVisual = "checkpoint-visual",
  CheckPointIoT = "checkpoint-iot",
  CheckPointSCB = "checkpoint-scb",
  ALoRa = "alora",
  FIV = "fiv",
}
